import styled from 'styled-components'
import { Link } from 'react-router-dom'
import breakpoints from '../../config/settings/breakpoints'

export const Article = styled.article`
  max-width: 42rem;
  margin: 0 auto;
  padding: 2rem 1rem 3.5rem;

  @media ${breakpoints.device.sm} {
    padding: 3rem 1.5rem 5rem;
  }
`

export const Eyebrow = styled.p`
  margin: 0 0 0.5rem;
  font-size: 0.75rem;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: ${({ theme }) => theme.colors.action.primary.bgActive};
`

export const Title = styled.h1`
  margin: 0 0 0.5rem;
  font-size: clamp(1.5rem, 4vw, 2rem);
  font-weight: 700;
  letter-spacing: -0.03em;
  line-height: 1.2;
  color: ${({ theme }) => theme.colors.textPrimary};
`

export const Updated = styled.p`
  margin: 0 0 2rem;
  font-size: 0.8125rem;
  color: ${({ theme }) => theme.colors.textMuted};
`

export const SectionTitle = styled.h2`
  margin: 1.75rem 0 0.6rem;
  font-size: 1.0625rem;
  font-weight: 700;
  letter-spacing: -0.02em;
  color: ${({ theme }) => theme.colors.textPrimary};
`

export const Paragraph = styled.p`
  margin: 0 0 0.85rem;
  font-size: 0.9375rem;
  line-height: 1.65;
  color: ${({ theme }) => theme.colors.textSecondary};
`

export const List = styled.ul`
  margin: 0 0 0.85rem;
  padding-left: 1.2rem;
  font-size: 0.9375rem;
  line-height: 1.65;
  color: ${({ theme }) => theme.colors.textSecondary};

  li + li {
    margin-top: 0.35rem;
  }
`

export const InlineLink = styled(Link)`
  color: ${({ theme }) => theme.colors.action.primary.bgActive};
  font-weight: 600;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
`

export const MailLink = styled.a`
  color: ${({ theme }) => theme.colors.action.primary.bgActive};
  font-weight: 600;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
`